enum MessageActionType {
    // Any unknown action type
    Unknown = 'unknown',

    // Any web URL
    Url = 'url',

    // Overview actions
    Overview = 'overview',

    // Exhibit actions
    Exhibits = 'exhibits',
    ExhibitInformation = 'exhibit-information',
    ExhibitElements = 'exhibit-elements',
    ExhibitQuizzes = 'exhibit-quizzes',
    ExhibitNotes = 'exhibit-notes',
    ExhibitSponsorships = 'exhibit-sponsorships',
    ExhibitStream = 'exhibit-stream',

    // Collection actions
    Collections = 'collections',
    CollectionInformation = 'collection-information',

    // Facility actions
    Facilities = 'facilities',
    FacilityInformation = 'facility-information',
    FacilityNotes = 'facility-notes',

    // Trail actions
    Trails = 'trails',
    TrailInformation = 'trail-information',

    // Event actions
    Events = 'events',
    EventInformation = 'event-information',

    // Quiz actions
    Quizzes = 'quizzes',
    QuizInformation = 'quiz-information',

    // Ticket actions
    Tickets = 'tickets',
    TicketInformation = 'ticket-information',

    // Membership actions
    Memberships = 'memberships',
    MembershipInformation = 'membership-information',

    // Voucher actions
    Vouchers = 'vouchers',
    VoucherInformation = 'voucher-information',

    // Visit actions
    Visits = 'visits',
    VisitInformation = 'visit-information',

    // Site actions
    Sites = 'sites',
    SiteInformation = 'site-information',

    // Article actions
    Articles = 'articles',
    ArticleInformation = 'article-information',

    // Activity actions
    Activities = 'activities',
    ActivityInformation = 'activity-information',

    // Achievement actions
    Achievements = 'achievements',
    AchievementInformation = 'achievement-information',

    // Frame actions
    Frames = 'frames',
    FrameInformation = 'frame-information',

    // User actions
    User = 'user',

    // Deprecated
    Explore = 'explore',
    Plan = 'plan',
    News = 'news',
    Wallet = 'wallet',
    Exhibit = 'exhibit',
    Event = 'event',
    Article = 'article',
}

export default MessageActionType